// @flow

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import * as AuthActions from '../../actions/auth';
import logo from '../../assets/images/logo.png';
import './Navbar.css';

class Navbar extends Component {

  handleLogout(event) {
    event.preventDefault();
    this.props.actions.logout();
  }

  render() {
    return (
      <header className="navbar">
        <div className="container navbar__container">
          <ul className="navbar__list">
            <li className="navbar__list-item">
              <Link
                className="navbar__link"
                to="https://www.join.me"
                target="_blank"
              >JOIN.ME</Link>
            </li>
            <li className="navbar__list-item">
              <Link
                className="navbar__link"
                to="#"
                onClick={(event) => this.handleLogout(event)}
              >LOGOUT</Link>
            </li>
          </ul>
          <h1 className="navbar__logo">
            <a href="/" title="Zoek">
              <img src={logo} alt="Zoek"/>
            </a>
          </h1>
        </div>
      </header>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(AuthActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navbar);


// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js